import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Protegge le rotte legate alla profilazione medica e al profilo utente
 * (`/profilazione-medico`, `/profilo`, `/utenti/:id`).
 *
 * Quando `environment.profiling` e' false la feature e' disattivata: la rotta
 * non e' raggiungibile e l'utente viene rimandato alla home, cosi' un vecchio
 * link salvato non porta a una pagina vuota. Rimettendo il flag a true tutto
 * torna accessibile senza altre modifiche.
 */
export const ProfilingEnabledGuard: CanActivateFn = () => {
	if (environment.profiling) return true;

	return inject(Router).createUrlTree(['/home']);
};
